export { UserConsentError } from './user-consent-error';
